import api from '~/api'

const state = {
  apiKey: {},
}

const getters = {}

const mutations = {
  SET_API_KEY(state, apiKey) {
    state.apiKey = apiKey
  },
}

const actions = {
  async showApiKey({ commit }, { id }) {
    const [error, success] = await api.get(`/api-keys/${id}`)
    if (!error) {
      commit('SET_API_KEY', success)
    }
    return [error, success]
  },
  async createApiKey({ commit }, { form }) {
    const [error, success] = await api.post('/api-keys', form)
    if (!error) {
      commit('SET_API_KEY', success)
    }
    return [error, success]
  },
  async updateApiKey({ commit }, { id, form }) {
    const [error, success] = await api.put(`/api-keys/${id}`, form)
    if (!error) {
      commit('SET_API_KEY', success)
    }
    return [error, success]
  },
  async deleteApiKey({ commit }, { id }) {
    const [error, success] = await api.delete(`/api-keys/${id}`)
    if (!error) {
      commit('SET_API_KEY', {})
    }
    return [error, success]
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
